<template>
  <div>
    <wtForm>
      <template slot="left">
        <SecurityRoleFilter></SecurityRoleFilter>
      </template>

      <template slot="right">
        <SecurityRole></SecurityRole>
      </template>
    </wtForm>
  </div>
</template>

<script>
/** RECURSOS DO VUE **/
//import { baseApiUrl, baseApiPort } from "@/global";
//import axios from "axios";

/** COMPONENTS - LAYOUT **/
import wtForm from "@/components/forms/wtForm";

/** COMPONENTS **/
import SecurityRole from "@/modules/security_ds/internal/security_role/SecurityRole";
import SecurityRoleFilter from "@/modules/security_ds/internal/security_role/SecurityRoleFilter";

export default {
  name: "SecurityRoleContainer",
  components: { wtForm, SecurityRole, SecurityRoleFilter },
  computed: {
    showFilter() {
      return this.$store.state.toolbars.showFilter;
    }
  },

  data: function() {
    return {
      //roleType: [{ value: null, text: "---" }]
    };
  },
  methods: {
    mudarTab() {
      this.$nextTick(() => {
        this.tabIndex++;
      });
    }
  },
  watch: {},
  created() {
    this.$store.commit("setTypeLayout", 2);
    this.$store.commit(
      "setUrlServicesStore",
      "security-ds/api/internal/security-role"
    );
  },
  mounted() {},
  beforeDestroy() {
    this.$store.commit("setObjFilter", {});
    this.$store.commit("setResetFilter", false);
    this.$store.commit("setApplyFilter", false);
  }
};
</script>

<style>
</style>
